export const fallbackSiteSettings = {
  styleParams: {},
  siteColors: {},
  siteTextPresets: {},
  fonts: {
    title: {
      fontWeight: 'normal',
      fontStyle: 'normal',
      fontVariant: 'normal',
      fontSize: '15px',
      lineHeight: '1.4em',
      fontFamily: 'din-next-w01-light, din-next-w02-light, din-next-w10-light, sans-serif',
    },
    trackTitle: {
      fontWeight: 'normal',
      fontStyle: 'normal',
      fontVariant: 'normal',
      fontSize: '15px',
      lineHeight: '1.4em',
      fontFamily: 'din-next-w01-light, din-next-w02-light, din-next-w10-light, sans-serif',
    },
  },
};
